var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"ws-icon",class:[_vm._iconClass,{button:_vm._hasClickListener}],style:([{'font-size':(_vm.size + "px")}]),on:{"click":function($event){return _vm.$emit('click',$event)}}},[_vm._v(_vm._s(_vm._icon))])}
var staticRenderFns = []

export { render, staticRenderFns }